import ReactDOM from "react-dom/client";

import { renderBootShell } from "./boot/renderBootShell";

import "./index.css";

const BASE_PATH = "/etsy";
if (!window.location.pathname.startsWith(BASE_PATH)) {
  window.location.replace(BASE_PATH + window.location.search + window.location.hash);
}

const rootElement = document.getElementById("root") as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

renderBootShell(root);

void import("./mainApp").then(({ startMainApp }) => {
  startMainApp(root);
});
